// helpers/rutaObserva.js
import axios from "axios";

const BASE_URL = "https://backsanpancracio.us-3.evennode.com";

// ✅ GET: Traer todas las observas
export const getObservas = async () => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/observas`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data; // { ok, observas, cantidad }
  } catch (error) {
    return { ok: false, error: error.response?.data || "Error al obtener observas" };
  }
};

// ✅ GET: Traer una observa por ID
export const getObservaById = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/observas/${id}`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data; // { ok, observa }
  } catch (error) {
    return { ok: false, error: error.response?.data || "Error al obtener observa" };
  }
};

// ✅ POST: Crear nueva observa
export const postObserva = async (observaData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/observas`;

  try {
    const resp = await axios.post(url, observaData, {
      headers: { "Content-Type": "application/json", token },
    });
    return resp.data; // { ok, observa }
  } catch (error) {
    return { ok: false, error: error.response?.data || "Error al crear observa" };
  }
};

// ✅ PUT: Actualizar observa
export const putObserva = async (id, observaData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/observas/${id}`;

  try {
    const resp = await axios.put(url, observaData, {
      headers: { "Content-Type": "application/json", token },
    });
    return resp.data; // { ok, observa }
  } catch (error) {
    return { ok: false, error: error.response?.data || "Error al actualizar observa" };
  }
};

// ✅ DELETE: Desactivar (soft delete) observa
export const deleteObserva = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/observas/${id}`;

  try {
    const resp = await axios.delete(url, { headers: { token } });
    return resp.data; // { ok, observa }
  } catch (error) {
    return { ok: false, error: error.response?.data || "Error al eliminar observa" };
  }
};
